/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMsIcon20Light = forwardRef('ShapeCircleMsIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 10a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z" })));
});
